"use strict";
import { createElement, StrictMode } from "react";
import { createRoot as createReactRoot } from "react-dom/client";
export function createRoot(container) {
  const root = createReactRoot(container);
  const strict = process.env.NODE_ENV === "development";
  return {
    render: (node) => root.render(strict ? createElement(StrictMode, null, node) : node),
    unmount: () => root.unmount()
  };
}
